import { render } from "./Questions.vue?vue&type=template&id=4ce0b0ae&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=4ce0b0ae&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-next-gen\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce0b0ae"]])

export default __exports__